import { Link } from "react-router-dom";
import { Youtube, Heart } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-brand-ink text-brand-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div className="space-y-4 max-w-sm">
            <Link2Logo />
            <p className="text-sm leading-relaxed text-brand-paper/70">
              We don't host videos. We're a <span className="text-brand-lime font-bold">curator</span>: we
              search the universe of YouTube via the official API, judge the teaching (not the views), and
              sequence the best free lessons into one clear, personalized course. We charge only for our
              curation — never for the videos.
            </p>
            <p className="text-sm text-brand-paper/70 flex items-center gap-2">
              <Youtube className="h-4 w-4 text-brand-pink" /> All lessons play in the official YouTube player.
            </p>
          </div>

          <div className="space-y-3">
            <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-brand-paper/50">Product</p>
            <ul className="space-y-2 text-sm text-brand-paper/80">
              <li><Link to="/pricing" className="hover:text-brand-lime transition-colors" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/about" className="hover:text-brand-lime transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/register" className="hover:text-brand-lime transition-colors">Get started</Link></li>
            </ul>
          </div>

          <div className="space-y-3">
            <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-brand-paper/50">Learning paths</p>
            <ul className="space-y-2 text-sm text-brand-paper/80">
              <li><Link to="/paths" className="hover:text-brand-lime transition-colors" data-testid="footer-paths">All paths</Link></li>
              <li><Link to="/paths/zero-to-prompt-engineering" className="hover:text-brand-lime transition-colors">Prompt Engineering</Link></li>
              <li><Link to="/paths/ai-for-business-owners" className="hover:text-brand-lime transition-colors">AI for Business Owners</Link></li>
              <li><Link to="/paths/ai-for-students" className="hover:text-brand-lime transition-colors">AI for Students</Link></li>
              <li><Link to="/paths/master-chatgpt" className="hover:text-brand-lime transition-colors">Master ChatGPT</Link></li>
            </ul>
          </div>

          <div className="space-y-3">
            <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-brand-paper/50">AI tool courses</p>
            <ul className="space-y-2 text-sm text-brand-paper/80">
              <li><Link to="/ai-tools" className="hover:text-brand-lime transition-colors" data-testid="footer-ai-tools">All AI tools</Link></li>
              <li><Link to="/ai-tools/chatgpt" className="hover:text-brand-lime transition-colors">Learn ChatGPT</Link></li>
              <li><Link to="/ai-tools/gemini" className="hover:text-brand-lime transition-colors">Learn Gemini</Link></li>
              <li><Link to="/ai-tools/midjourney" className="hover:text-brand-lime transition-colors">Learn Midjourney</Link></li>
              <li><Link to="/ai-tools/cursor" className="hover:text-brand-lime transition-colors">Learn Cursor</Link></li>
            </ul>
          </div>

          <div className="space-y-3">
            <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-brand-paper/50">Legal & Compliance</p>
            <ul className="space-y-2 text-sm text-brand-paper/80">
              <li><Link to="/youtube-compliance" className="hover:text-brand-lime transition-colors" data-testid="footer-compliance">YouTube API Compliance</Link></li>
              <li><Link to="/terms" className="hover:text-brand-lime transition-colors" data-testid="footer-terms">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-brand-lime transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer" className="hover:text-brand-lime transition-colors">YouTube Terms ↗</a></li>
              <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-brand-lime transition-colors">Google Privacy ↗</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-brand-paper/10 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
          <p className="text-xs text-brand-paper/50 flex items-center gap-1.5">
            © {new Date().getFullYear()} AI PATHSHAALAA · MADE WITH <Heart className="h-3 w-3 fill-brand-pink text-brand-pink" /> IN INDIA
          </p>
          <p className="text-xs text-brand-paper/40">Not affiliated with, endorsed by, or sponsored by YouTube or Google.</p>
        </div>
      </div>
    </footer>
  );
}

function Link2Logo() {
  return (
    <div className="flex items-center gap-2.5">
      <span className="grid place-items-center h-9 w-9 rounded-xl bg-brand-lime">
        <span className="font-heading font-black text-brand-ink text-lg">P</span>
      </span>
      <span className="font-heading font-extrabold text-lg tracking-tight text-brand-paper">AI Pathshaalaa</span>
    </div>
  );
}
